import { InteractionRequiredAuthError } from "@azure/msal-browser";
import axios from "axios";
import { useState, useEffect } from "react";
import { AccessToken } from "../../config/AccessToken";
import { ConversionsChart } from "./ConversionsChart";
import { useLocalization } from "@progress/kendo-react-intl";

export const AlarmsTile = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [error, setError] = useState('');
    const [instance, accessTokenRequest] = AccessToken();
    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');       

    const [counterAlarms, setCounterAlarms] = useState<number>(0);
    const [counterOutOfCoverage, setCounterOutOfCoverage] = useState<number | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingOutOfCoverage, setLoadingOutOfCoverage] = useState<boolean>(true);

    useEffect(() => {
      getAlarmCounter();
    }, []);
  
    const getAlarmCounter =  () => {
      
      const fetchAlarmCount = async (headers: any) => {
        setLoading(true);

        try {
          const countRes = await axios.get(`${SERVER_URL}/alarm/count`, { headers });
          const countValue = Number(countRes?.data?.data?.alarmCount ?? countRes?.data?.alarmCount ?? 0);
          setCounterAlarms(Number.isFinite(countValue) ? countValue : 0);
        } catch (data: any) {
          setError(data?.message);
        } finally {
          setLoading(false);
        }
      };

      const fetchOutOfCoverageCount = async (headers: any) => {
        setLoadingOutOfCoverage(true);

        try {
          const outOfCoverageRes = await axios.get(`${SERVER_URL}/alarm/CountByEventType/4`, { headers });
          const outOfCoverageValue = Number(outOfCoverageRes?.data.data.alarmCount);

          setCounterOutOfCoverage(Number.isFinite(outOfCoverageValue) ? outOfCoverageValue : 0);
        } catch (data: any) {
          setError(data?.message);
          setCounterOutOfCoverage(0);
        } finally {
          setLoadingOutOfCoverage(false);
        }
      };

      const commonOperations =  (accessToken: any) => {
        const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId  };
        Promise.allSettled([
          fetchAlarmCount(headers),
          fetchOutOfCoverageCount(headers),
        ]);
      }
  
      if (localStorage.getItem('accessToken') != null) {
        let accessToken = localStorage.getItem('accessToken');
         commonOperations(accessToken);
      } else {
         instance.initialize();
         instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
          // Acquire token silent success
          let accessToken = accessTokenResponse.accessToken;
          return commonOperations(accessToken);
        })
          .catch((error: any) => {
            if (error instanceof InteractionRequiredAuthError) {
              instance.acquireTokenRedirect(accessTokenRequest);
            }
            console.log(error);
            setLoading(false);
            setLoadingOutOfCoverage(false);
          });
      }
    }
   
    return (
      <div style={{ position: 'relative', minHeight: '170px' }}>
        <div
          style={{
            zoom: '65%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '8px',
            position: 'relative',
            top: '30px',
          }}
        >
          <ConversionsChart
            firstValue={counterAlarms}
            secondValue={counterOutOfCoverage ?? 0}
            firstLabel={localizationService.toLanguageString('dashboard.widget.alarms_counter', 'NOT_FOUND')}
            secondLabel={localizationService.toLanguageString('dashboard.widget.devices_status.device_out_of_field', 'Dispositivo fuori copertura')}
            firstLabelLoading={loading}
            secondLabelLoading={loadingOutOfCoverage || counterOutOfCoverage === null}
          />
        </div>
      </div>      
    );
  };